import { useEffect, useRef } from 'react';
import { NavigationToggle } from '@components/NavigationToggle';
import { TProps } from './types/TProps';

export const NavigationDrawer = ({ open, onClose, children }: TProps) => {
  const dialogRef = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const dialog = dialogRef.current;
    if (!dialog || !open) {
      return;
    }
    const previousFocus = document.activeElement;
    const previousOverflow = document.body.style.overflow;
    dialog.showModal();
    document.body.style.overflow = 'hidden';
    return () => {
      dialog.close();
      document.body.style.overflow = previousOverflow;
      if (previousFocus instanceof HTMLElement && previousFocus.isConnected) {
        previousFocus.focus();
      }
    };
  }, [open]);

  return (
    <dialog
      ref={dialogRef}
      id="mobile-navigation"
      aria-label="Main navigation"
      className="fixed inset-y-0 left-0 right-auto m-0 h-dvh max-h-dvh w-[280px] max-w-[calc(100vw-2rem)] overflow-y-auto border-0 bg-surface p-0 text-foreground backdrop:bg-overlay"
      onCancel={(event) => {
        event.preventDefault();
        onClose();
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) {
          const bounds = event.currentTarget.getBoundingClientRect();
          if (
            event.clientX < bounds.left ||
            event.clientX > bounds.right ||
            event.clientY < bounds.top ||
            event.clientY > bounds.bottom
          ) {
            onClose();
          }
        }
        if (event.target instanceof Element && event.target.closest('a[href]')) {
          onClose();
        }
      }}
    >
      <div className="flex justify-start border-b border-border px-4">
        <NavigationToggle expanded={open} onClick={onClose} />
      </div>
      {children}
    </dialog>
  );
};
